import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {useGetMaterials} from "../api/get-materials";
import {useEEToolContext} from "../contexts/eeToolContext";
import {useEffect, useState} from "react";
import {useGetColors} from "../api/get-colors";
import {useGetEdges} from "../api/get-edges";
import {Edge} from "../types/Edge";
import {ColorPopupResult} from "../types/ColorPopupResult";

export function ColorPopupControl() {
    const context = useEEToolContext()
    const adapterContext = useEEToolAdapterContext()
    const materials = useGetMaterials(context.dealerId, context.customerZip, adapterContext.popupColorVisible);
    const colors = useGetColors(context.dealerId, adapterContext.edgeColorP, context.estimateDate, context.customerZip, adapterContext.popupColorVisible);
    const edges = useGetEdges(context.dealerId, adapterContext.edgeColorP, context.estimateDate, context.customerZip, adapterContext.popupColorVisible);
    const [edgesSource, setEdgesSource] = useState<Edge[]>([]);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: async () => {
            let ec: ColorPopupResult = {
                p: adapterContext.edgeColorP,
                pText: materials.data?.find(x => x.prodQteGrpID === adapterContext.edgeColorP)?.name ?? '',
                c: adapterContext.edgeColorC,
                cText: colors.data?.find(x => x.productID == adapterContext.edgeColorC)?.name ?? '',
                e1: adapterContext.edgeColorE1 === 0 ? 'none' : adapterContext.edgeColorE1,
                e1Text: edgesSource.find(x => x.productID == adapterContext.edgeColorE1)?.name ?? ''
            };

            adapterContext.handleColor(ec);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupColor()
    };

    useEffect(() => {
        if (!edges.data)
            return;
        let result: Edge[] = [];
        result.push({productID: 0, name: 'None Selected', imageUrl: '', amount: 0, length: 0})
        edges.data.forEach((x) => result.push(x));
        setEdgesSource(result);
    }, [edges.data])


    const renderItem = (itemData: Edge) => {
        return (
            <div><p style={{marginTop: 0, marginBottom: '6px'}}>{itemData.name}</p>
                <img
                    style={{
                        height: '40px',
                        width: '75px',
                        float: 'right',
                        visibility: itemData.productID === 0 ? 'hidden' : 'visible'
                    }}
                    src={itemData.imageUrl}/></div>
        );
    };

    if (!adapterContext.popupColorVisible)
        return <></>;

    return (
        <>
            <Popup
                title='Select Product and Color'
                visible={adapterContext.popupColorVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupColor()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    disabled={adapterContext.edgeColorC === 0}
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <SelectBox
                            label={"Product:"}
                            labelMode={'outside'}
                            width={'100%'}
                            dataSource={materials.data}
                            disabled={materials.isLoading}
                            displayExpr="name"
                            valueExpr="prodQteGrpID"
                            value={adapterContext.edgeColorP}
                            onValueChanged={(e) => {
                                adapterContext.setEdgeColorC(0);
                                adapterContext.setEdgeColorE1(0);
                                adapterContext.setEdgeColorP(e.value);
                            }
                            }
                            searchEnabled={true}
                        />
                    </div>
                    <div className="dx-field">
                        <SelectBox
                            label={"Color:"}
                            labelMode={'outside'}
                            width={'100%'}
                            dataSource={colors.data}
                            disabled={colors.isLoading || adapterContext.edgeColorP === 0}
                            displayExpr="name"
                            valueExpr="productID"
                            value={adapterContext.edgeColorC}
                            onValueChanged={(e) => adapterContext.setEdgeColorC(e.value)}
                            searchEnabled={true}
                        />
                    </div>
                    <div className="dx-field">
                        <SelectBox
                            label={"Edge:"}
                            labelMode={'outside'}
                            width={'100%'}
                            dataSource={edgesSource}
                            disabled={edges.isLoading || adapterContext.edgeColorP === 0}
                            displayExpr="name"
                            valueExpr="productID"
                            value={adapterContext.edgeColorE1}
                            onValueChanged={(e) => adapterContext.setEdgeColorE1(e.value)}
                            searchEnabled={true}
                            itemRender={renderItem}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
